<div class="panel-body " *ngIf="allegationResult===undefined">
    <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
        <div class="panel-title">
          Allegation Result
        </div>
        <div class="panel-body ">
          No Allegation Result information available for this allegation.
        </div>
    </div>
</div>
<div class="panel-body " *ngIf="allegationResult!==undefined">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
    <div class="panel-title">
      Allegation Result
    </div>
   <div class="panel-body ">
      <div class="col-md-6 panel panel-default">
          <div class="panel panel-default " *ngIf="allegationResult.getAdjDate() !== ''">
          <div class="panel-title">
              Adjudication Date
          </div>
          <div class="panel-body">
            {{allegationResult.getAdjDate() | date:'MM/dd/yyyy'}}
          </div>
          </div>
          <div class="panel panel-default" *ngIf="allegationResult.getParents().length !==0">
          <div class="panel-title">
              Parent/Guardian/Custodian Assigned
          </div>
          <div class="panel-body" *ngFor="let parent of allegationResult.getParents(); let al = index">
              {{parent.getPartyName()+ ' (' + parent.getRelationship() + ')'}}
          </div>
          </div>
      </div>
      <div class="col-sm-6 panel panel-default ">
        <div class="panel panel-default " *ngIf="allegationResult.getAdjEoDate() !== ''">
        <div class="panel-title">
          Adjudication EO Date
        </div>
        <div class="panel-body">
            {{allegationResult.getAdjEoDate() | date:'MM/dd/yyyy'}}
        </div>
        </div>
        <div class="panel panel-default" *ngIf="allegationResult.getAttorneys().length !== 0">
          <div class="panel-title">
            Attorneys Representing
          </div>
          <div class="panel-body" *ngFor="let attorneyName of allegationResult.getAttorneys();" >
              {{attorneyName}} <br>
          </div>
        </div>
      </div>
      </div>
      <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
          <div class="panel panel-default" *ngIf="allegationResult.getOtherAllegations().length !=0">
          <div class="panel-title">
            Other Allegations Included On Order
          </div>
          <div class="panel-body" >
              <div class="row table-responsive">
                  <table id="allegations-table" class="table table-condensed table-striped">
                      <thead>
                          <tr>
                              <th id="V122c">
                                <span class="field-code ">V122c json='allegations.pleadingType'</span>
                                Pleading Type <br> 
                                <span class="field-code ">V122c json='allegations.clockDate'</span>
                                And Clock Date
                              </th>
                              <th id="V121c">
                                <span class="field-code ">V121c json='allegations.allegation'</span>
                                  Allegation <br>
                                  <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                  Offense Date
                                </th>
                               </tr>
                      </thead>
                      <tbody  *ngFor="let otherAllegation of allegationResult.getOtherAllegations()let i = index;">                            
                           <tr >
                            <td id="{{'juvenile-caseDetails-allegationResult-' + i + '-pleadingType'}}">
                              {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                              {{otherAllegation.getOtherPleadingDate() | date:'MM/dd/yyyy'}} {{otherAllegation.getOtherPleadingTime()}}</td>
                            <td id="{{'juvenile-caseDetails-allegationResult-' + i + '-allegationDescription'}}">
                              {{otherAllegation.getOtherAllegationDescription()}} <br>        
                              {{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
                          </tr>    
                         </tbody>
                  </table>
              </div>
          </div>
          </div>
        <div class="panel panel-default" *ngIf="allegationResult.getAllegationProvenCode() !== ''">
          <div class="panel-title">
            Findings
          </div>
         <div class="panel-body">
            <B>Based on the evidence provided:</B>
            <ul style="list-style-type:disc">
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'NAP'" >
                  <li>Allegations Not Proven</li>
                  <li>Juvenile Admitted Allegations</li>
                  <li>Following Facts have been Proven beyond reasonable doubt:</li>
                      <ul style="list-style-type:disc">
                          <span *ngIf="allegationResult.getFactsFound()!==''">
                          <li> {{allegationResult.getFactsFound()}} </li></span>
                      </ul>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'NA'" >
                  <li>Allegations Not Proven</li>
                  <li>Juvenile Admitted Allegations</li>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'AP'" >
                  <li>Juvenile Admitted Allegations</li>
                  <li>Following Facts have been Proven beyond reasonable doubt:</li>
                      <ul style="list-style-type:disc">
                          <span *ngIf="allegationResult.getFactsFound()!==''">
                          <li> {{allegationResult.getFactsFound()}} </li></span>
                      </ul>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'NP'" >
                  <li>Allegations Not Proven</li>
                  <li>Following Facts have been Proven beyond reasonable doubt:</li>
                      <ul style="list-style-type:disc">
                          <span *ngIf="allegationResult.getFactsFound()!==''">
                          <li> {{allegationResult.getFactsFound()}} </li></span>
                      </ul>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'N'" >
                  <li>Allegations Not Proven</li>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'A'" >
                  <li>Juvenile Admitted Allegations</li>
                </div>
                <div *ngIf="allegationResult.getAllegationProvenCode() === 'P'" >
                  <li>Following Facts have been Proven beyond reasonable doubt:</li>
                  <ul style="list-style-type:disc">
                    <span *ngIf="allegationResult.getFactsFound()!==''">
                      <li>{{allegationResult.getFactsFound()}} </li></span>
                  </ul>
                </div>
            </ul>
         </div>
        </div>
      <div class="panel panel-default" *ngIf="allegationResult.getLawConclusionCode()!==''">
          <div class="panel-title">
            Conclusions of Law
          </div>
          <div class="panel-body">
            <B>Based on the evidence presented:</B>
            <ul style="list-style-type:disc">
                <div *ngIf="allegationResult.getLawConclusionCode() === 'NJ'" >
                  <li> Juvenile Not Within Jurisdiction of the Court.</li>
                </div>
                <div *ngIf="allegationResult.getLawConclusionCode() === 'IJ'" >
                  <li>Juvenile is within the jurisdiction of the Court as a delinquent juvenile.</li>
                  <span *ngIf="allegationResult.getJuvenileOffenseDegreeCode()!==''">
                  <ul style="list-style-type:disc">
                      <div *ngIf="allegationResult.getJuvenileOffenseDegreeCode() === 'A'" >
                        <li>Minor (Class 1,2 or 3)</li>
                      </div>
                      <div *ngIf="allegationResult.getJuvenileOffenseDegreeCode() === 'B'" >
                        <li>Serious (F-I or Class AI)</li>
                      </div>
                      <div *ngIf="allegationResult.getJuvenileOffenseDegreeCode() === 'C'" >
                        <li>Violent (Class A-E)</li>
                      </div>
                  </ul></span>
                </div>
            </ul>
          </div>
      </div>
      <div class="panel panel-default" 
      *ngIf="allegationResult.getOrderCode()!=='' || (allegationResult.getAlcoholTestInd()!=='' || allegationResult.getControlledSubstanceTestInd()!=='' || 
      allegationResult.getFingerprintPhotographInd()!=='' || allegationResult.getOtherCourtOrderInd()!=='')">
          <div class="panel-title">
            Order
          </div> 
          <div class="panel-body">
            <span *ngIf="allegationResult.getOrderCode()!==''">
            <B>It is therefore ORDERED that the case:</B>
            <ul style="list-style-type:disc">
                <div *ngIf="allegationResult.getOrderCode() === 'D'" >
                  <li>be dismissed.</li>
                </div>
                <div *ngIf="allegationResult.getOrderCode() === 'PD'" >
                  <li>proceed to disposition.</li>
                </div>
                <div *ngIf="allegationResult.getOrderCode() === 'TC'" >
                  <li>be transferred to {{allegationResult.getTransferCountyName()}} County of Disposition</li>
                </div>
                <div *ngIf="allegationResult.getOrderCode() === 'CD'" >
                  <li>be continued for disposition until {{allegationResult.getContinueDisposeDate()}}</li>
                  <ul style="list-style-type:disc">
                      <div *ngIf="allegationResult.getUnderFollowingConditionInd() === 'Y'" >
                        <li>under the following conditions:</li>
                        <span *ngIf="allegationResult.getUnderConditions() !== ''">
                        <ul style="list-style-type:disc">
                          <li>{{allegationResult.getUnderConditions()}}</li>
                        </ul></span>
                      </div>
                  </ul>
                </div>
            </ul></span>
            <span *ngIf="allegationResult.getAlcoholTestInd()!=='' || allegationResult.getControlledSubstanceTestInd()!=='' || 
            allegationResult.getFingerprintPhotographInd()!=='' || allegationResult.getOtherCourtOrderInd()!==''">
            <B>The Court further ORDER(S):</B>
            <ul style="list-style-type:disc">
                <div *ngIf="allegationResult.getAlcoholTestInd() === 'Y'" >
                  <li>Alcohol Testing [7B-2502(a)]</li>
                </div>
                <div *ngIf="allegationResult.getControlledSubstanceTestInd() === 'Y'" >
                  <li>Controlled Substance Testing [7B-2502(a)]</li>
                </div>
                <div *ngIf="allegationResult.getFingerprintPhotographInd() === 'Y'" >
                  <li>Fingerprints/Photographs [7B-2102(b)] by {{allegationResult.getFingerPrintOfficerName()}} (name of law enforcement officer/agency)</li>
                </div>
                <div *ngIf="allegationResult.getOtherCourtOrderInd() === 'Y'" >
                  <li>Other:</li>
                  <span *ngIf="allegationResult.getOtherOrderText()!==''">
                  <ul style="list-style-type:disc">
                    <li>{{allegationResult.getOtherOrderText()}}</li>
                  </ul></span>
                </div>
             </ul></span>
          </div>   
      </div>
  </div>
 </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/allegation-result/allegation-result.component.html